import { PageEvent } from "@angular/material/paginator";
import { PaginationOptions } from "../models/filter.model";

export const DefaultPaginationOptions: PaginationOptions = {
  page: 0,
  limit: 10
};

export interface PagedMetadata {
  pageSize: number;
  pageIndex: number;
  pagedList: any[];
}

export function handleClientSidePageChangeEvent(e: PageEvent, list: any[]): PagedMetadata {
   const pageSize = e.pageSize;
    const pageIndex = e.pageIndex;

    let startIndex = pageIndex * pageSize;
    
    const pagedList = list!.slice(startIndex, startIndex + pageSize);

    return {pageSize, pageIndex, pagedList};
    
}